import { render, staticRenderFns } from "./sorting_dialog.vue?vue&type=template&id=23f18b96&scoped=true&"
import script from "./sorting_dialog.vue?vue&type=script&lang=js&"
export * from "./sorting_dialog.vue?vue&type=script&lang=js&"
import style0 from "./sorting_dialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./sorting_dialog.vue?vue&type=style&index=1&id=23f18b96&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f18b96",
  null
  
)

export default component.exports